// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__5cW30","detailsBorder":"styles_detailsBorder__2_yA3"};